import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ClipboardList } from "lucide-react";
import { EQUIPMENT_TYPES } from "@/lib/status";

const ORIGINS = [
  ["garantia", "Garantia fabricante"], ["contrato", "Contrato de manutenção"], ["particular", "Particular"],
  ["instalacao", "Instalação"], ["retorno", "Retorno"],
];
const STATUSES = [
  ["concluido", "Concluído"], ["aguardando_peca", "Aguardando peça"], ["aguardando_aprovacao", "Aguardando aprovação"],
  ["retorno_tecnico", "Retorno técnico"], ["sem_reparo", "Equipamento sem reparo"], ["cancelado", "Cancelado"],
];

export default function OsClassification({ origin, onOrigin, status, onStatus, travel, onTravel, eqType, onEqType, disabled }) {
  const types = eqType && !EQUIPMENT_TYPES.includes(eqType) ? [eqType, ...EQUIPMENT_TYPES] : EQUIPMENT_TYPES;
  return (
    <div className="rounded-lg border border-slate-200 p-3 space-y-2" data-testid="os-classification-section">
      <Label className="text-sm flex items-center gap-1.5"><ClipboardList className="h-4 w-4 text-[#1e7be0]" /> Origem, status e deslocamento</Label>
      <div className="grid sm:grid-cols-2 gap-2">
        {onEqType && <div className="space-y-1.5 sm:col-span-2">
          <Label className="text-xs">Tipo de equipamento</Label>
          <Select value={eqType || "none"} disabled={disabled} onValueChange={(v) => onEqType(v === "none" ? "" : v)}>
            <SelectTrigger data-testid="os-equipment-type-select"><SelectValue placeholder="Selecione" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">Não informado</SelectItem>
              {types.map((t) => <SelectItem key={t} value={t} data-testid={`os-eq-type-${t}`}>{t}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>}
        <div className="space-y-1.5">
          <Label className="text-xs">Origem do chamado</Label>
          <Select value={origin} disabled={disabled} onValueChange={onOrigin}>
            <SelectTrigger data-testid="os-origin-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {ORIGINS.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`os-origin-${v}`}>{l}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs">Status do atendimento</Label>
          <Select value={status || "none"} disabled={disabled} onValueChange={(v) => onStatus(v === "none" ? "" : v)}>
            <SelectTrigger data-testid="os-attendance-status-select"><SelectValue placeholder="Selecione" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">Não definido</SelectItem>
              {STATUSES.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`os-attendance-${v}`}>{l}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs">Deslocamento (R$)</Label>
          <Input type="number" min="0" step="0.01" value={travel} disabled={disabled}
            onChange={(e) => onTravel(e.target.value)} placeholder="0,00" data-testid="os-travel-value-input" />
        </div>
      </div>
    </div>
  );
}
